// import React, { useEffect, useState } from 'react'
// import ReactDatePicker from "react-datepicker";
// import { Button } from "../../common/Button/Button";
// import IhclMainTable from './IhclMainTable';
// import AgeWiseIhclTable from './AgeWiseIhclTable';
// import SectorWiseIhclTable from './SectorWiseIhclTable';
// import FamilyIncomeIhclTable from './FamilyIncomeIhclTable';
// import IncomeIhclTable from './IncomeIhclTable';
// import api from '../../utils/api';
// import Spinner from '../../common/Spinner/Spinner';
// import DataPieChart from './DataPieChart';
// import CustomHistogramChart from './CustomHistogramChart';
// import HistogramTotalBeneficiaryChart from './HistogramTotalBeneficiaryChart';
// import CompliancePieChart from './CompliancePieChart';
// import MarketLinkagePieChart from './MarketLinkagePieChart';
// import DeliveredResourcePieChart from './DeliveredResourcePieChart';
// import { toast } from 'react-toastify';
// import IhclExpenseTable from './IhclExpenseTable';
// import { DOWNLOAD_API_URL } from '../../utils/constants';
// import KnowledgeSessionPieChart from './KnowledgeSessionPieChart';
// import { Info } from 'react-feather';



// const IhclDashboardContainer = () => {

//     const [fromDate, setfromDate] = useState();
//     const [toDate, settoDate] = useState();
//     const [ageWiseData, setAgeWiseData] = useState([])
//     const [sectorWiseData, setSectorWiseData] = useState([])
//     const [familyIncData, setFamilyIncData] = useState([])
//     const [businessIncData, setBusinessIncData] = useState([])
//     const [combineData, setCombineData] = useState([])
//     const [clearClicked, setClearClicked] = useState(false);
//     const [isLoading, setIsLoading] = useState(false)
//     const [countData, setCountData] = useState("")
//     const [mobilizationCountData, setMobilizationCountData] = useState("")
//     const [totalBeneChartData, setTotalBeneChartData] = useState([])
//     const [groupKnowledgeData, setGroupKnowliedgeData] = useState()
//     const [expertData, setExpertData] = useState()
//     const [marketConnectData, setMarketConnectData] = useState()
//     const [complianceData, setComplianceData] = useState()
//     const [blrpData, setBlrpData] = useState()
//     const [loadMore, setLoadMore] = useState(false)
//     const [filteredCompliance, setFilteredCompliance] = useState([])
//     const [filteredMarketLinkage, setFilteredMarketLinkage] = useState([])
//     const [summaryData, setSummaryData] = useState([])
//     const [jpmcExpsData, setJpmcExpsData] = useState([])

//     const [complianceReportData, setComplianceReportData] = useState()
//     const [groupKnowledgeSessionReportData, setGroupKnowledgeSessionReportData] = useState()

//     const [complianceRequested, setComplianceRequested] = useState()
//     const [complianceProgress, setComplianceProgress] = useState()
//     const [complianceDelivered, setComplianceDelivered] = useState()
//     const [complianceCancellled, setComplianceCancelled] = useState()

//     const [groupKnowledgeSessionRequested, setGroupKnowledgeSessionRequested] = useState()
//     const [groupKnowledgeSessionProgress, setGroupKnowledgeSessionProgress] = useState()
//     const [groupKnowledgeSessionDelivered, setGroupKnowledgeSessionDelivered] = useState()

//     const [expertConsultationRequested, setExpertConsultationRequested] = useState()
//     const [expertConsultationProgress, setExpertConsultationProgress] = useState()
//     const [expertConsultationDelivered, setExpertConsultationDelivered] = useState()
//     const [experConsultationCancelled, setExpertConsultationCancelled] = useState()

//     const [marketConnectRequested, setMarketConnectRequested] = useState()
//     const [marketConnectProgress, setMarketConnectProgress] = useState()
//     const [marketConnectDelivered, setMarketConnectDelivered] = useState()

//     const [blrpRequested, setBlrpRequested] = useState()
//     const [blrpProgress, setBlrpProgress] = useState()
//     const [socialMediaDelivered, setSocialMediaDelivered] = useState()
//     const [socialMediaCancelled, setSocialMediaCancelled] = useState()

//     const [groupknowledgesession, setgroupknowledgesession] = useState([])
//     const [marketlinkagesession, setmarketlinkagesession] = useState([])
//     const [compliancesession, setcompliancesession] = useState([])
//     const [expertconsultation, setexpertconsultation] = useState([])
//     const [blrpsession, setblrpsession] = useState([])

//     useEffect(() => {
//         const mobileWidthBreakpoint = 768;

//         const displayToastForMobileResolution = () => {
//             if (window.innerWidth < mobileWidthBreakpoint) {
//                 toast("This dashboard is best viewable in a desktop browser.", {
//                     autoClose: 5000,
//                     type: toast.TYPE.ERROR,
//                 });
//             }
//         };

//         displayToastForMobileResolution();

//         window.addEventListener('resize', displayToastForMobileResolution);

//         return () => window.removeEventListener('resize', displayToastForMobileResolution);
//     }, []);

//     const ondatechange = (key, date) => {
//         if (key === "fromDate") {
//             setfromDate(date)

//         } else if (key === "toDate") {
//             settoDate(date)

//         }
//     };

//     const dateAdjusted = (date) => {
//         let toDateAdjusted;
//         if (date) {
//             toDateAdjusted = new Date(date);

//             toDateAdjusted = new Date(
//                 toDateAdjusted.setTime(
//                     toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
//                 )
//             );
//         }
//         return toDateAdjusted;
//     }

//     const dateAdjusted1 = (date) => {
//         let toDateAdjusted;
//         if (date) {
//             toDateAdjusted = new Date(date);

//             toDateAdjusted = new Date(
//                 toDateAdjusted.setTime(
//                     toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
//                 )
//             );
//         }
//         return toDateAdjusted;
//     }

//     const filterAndCombineData = (data, keyToCompare) => {
//         const combinedData = {};

//         data.forEach(entry => {
//             const key = `${entry[keyToCompare]}_${entry.sResourceDisplayName}`;

//             if (combinedData[key]) {
//                 combinedData[key].sMobile_count += entry.sMobile_count;
//             } else {
//                 combinedData[key] = { ...entry };
//             }
//         });

//         const combinedDataArray = Object.values(combinedData);

//         return combinedDataArray;
//     };

//     useEffect(() => {
//         setSummaryData([
//             ["Expert Consultation", expertConsultationDelivered],
//             ["Market Connect", marketConnectDelivered],
//             ["Group Knowledge Session", groupKnowledgeSessionDelivered],
//             ["BLRP", socialMediaDelivered],
//             ["Compliance", complianceDelivered]
//         ])
//     }, [groupKnowledgeSessionDelivered, complianceDelivered, expertConsultationDelivered, marketConnectDelivered, socialMediaDelivered])

//     const getTableData = () => {
//         let filterParameters = {}

//         if (fromDate) {
//             filterParameters.fromDate = dateAdjusted1(fromDate)
//         }

//         if (toDate) {
//             filterParameters.toDate = dateAdjusted(toDate)
//         }

//         console.log("Filter", filterParameters)
//         setIsLoading(true)

//         let payload = {
//             // api_key : "r54B?rHXUE7v%$9t",
//             api_key: "82mqEyJnct4kzC8y",

//         }

//         const { tempMobilizationCount } = api.mobilizationCountApi(payload)
//             .then(({ data }) => {
//                 setMobilizationCountData(data.data.total_count)
//             })

//         const { tempCountData } = api.jpmcCountData(filterParameters)
//             .then(({ data }) => {
//                 console.log("COUNT", data.count)
//                 setCountData(data.count)
//             })

//         const { tempTotalBeneficiaryData } = api.ihcltotalBeneficiaryChartData(filterParameters)
//             .then(({ data }) => {
//                 console.log("Chart Data", data)
//                 setTotalBeneChartData(data)
//             })

//         const { tempJpmcExpenseData } = api.jpmcExpenseTableData(filterParameters)
//             .then(({ data }) => {
//                 console.log("Expense Data", data)
//                 setJpmcExpsData(data.data)
//             })

//         const { tempComplianceReport } = api.ihclgetComplianceReportAPI(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report Compliance", data)
//             })

//         const { tempExpertConsultaionReport } = api.ihclgetExpertConsultationReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report Expert", data)
//             })

//         const { tempMobilizationReport } = api.ihclgetMobilizationReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report Mobilization", data)
//             })

//         const { tempBlrpReport } = api.ihclgetIhclSocialMediaReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report blrp", data)
//             })

//         const { tempGroupKnowledgeReport } = api.ihclgetGroupKnowledgeReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report Groupknowledge", data)
//             })

//         const { tempGroupKnowledgeSessionReport } = api.ihclgetGroupKnowledgeSessionReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setgroupknowledgesession(`/${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });

//         const { tempMarketLinkageSessionReport } = api.ihclgetMarketLinkageSessionReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setmarketlinkagesession(`/${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });
//         const { tempComplianceSessionReport } = api.ihclgetComplianceSessionReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setcompliancesession(`/${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });
//         const { tempExpertConsultationSessionReport } = api.ihclgetExpertConsultationSessionReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setexpertconsultation(`/${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });
//         const { tempblrpSessionReport } = api.ihclgetSocialMediaAllData(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Group Knowledge Session Report", data);
//                 console.log("filterParameters", filterParameters)
//                 const fullPath = data.generated_file;
//                 const parts = fullPath.split('/');
//                 const filename = parts[parts.length - 1];

//                 setblrpsession(`/${filename}`);

//                 console.log("Generated File Path:", `/${filename}`);
//             });




//         const { tempMarketLinkage } = api.ihclgetMarketLinkageReport(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report MarketLinkage", data)
//             })

//         const { tempJpmcAllData } = api.getIhclAllData(filterParameters)
//             .then(({ data }) => {
//                 console.log("Data Report All", data);
//             })
//         let complianceCount = 0;
//         let complianceCountDelivered = 0;
//         let complianceCountRequested = 0;
//         let complianceCountProgress = 0;
//         let complianceCountCancelled = 0;

//         let groupKnowledgeSessionCount = 0;
//         let groupKnowledgeSessionCountDelivered = 0;
//         let groupKnowledgeSessionCountRequested = 0;
//         let groupKnowledgeSessionCountProgress = 0;
//         let groupKnowledgeSessionCountCancelled = 0;

//         let expertConsultationCount = 0;
//         let expertConsultationCountDelivered = 0;
//         let expertConsultationCountRequested = 0;
//         let expertConsultationCountProgress = 0;
//         let expertConsultationCountCancelled = 0;

//         let marketConnectCount = 0;
//         let marketConnectCountDelivered = 0;
//         let marketConnectCountRequested = 0;
//         let marketConnectCountProgress = 0;
//         let marketConnectCountCancelled = 0;

//         let blrpCount = 0;
//         let blrpCountDelivered = 0;
//         let blrpCountRequested = 0;
//         let blrpCountProgress = 0;
//         let blrpCountCancelled = 0;

//         let generatedFilePath;



//         const { tempComplianceReportData } = api.ihclgetComplianceReportDataAPI(filterParameters)
//             .then(({ data }) => {
//                 console.log("ComplianceData", data)
//                 setComplianceReportData(data.data)
//                 data.data.forEach(item => {
//                     complianceCount += item.sMobile_count || 0;

//                     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
//                         complianceCountCancelled += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "") {
//                         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                             item.refSRStateLPM === "Quotation Sent") {
//                             complianceCountRequested += item.sMobile_count || 0;
//                         }

//                         if (item.refSRStateLPM === "Payment Received") {
//                             complianceCountProgress += item.sMobile_count || 0;
//                         }
//                     }

//                     if (item.refCurrentStateSPM !== "") {
//                         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                             complianceCountProgress += item.sMobile_count || 0;
//                         }

//                         if (item.refCurrentStateSPM === "Delivered") {
//                             complianceCountDelivered += item.sMobile_count || 0;
//                         }
//                     }
//                 })

//                 setComplianceDelivered(complianceCountDelivered)
//                 setComplianceRequested(complianceCountRequested)
//                 setComplianceProgress(complianceCountProgress)
//                 setComplianceCancelled(complianceCountCancelled)
//                 setComplianceData(complianceCount)
//             })

//         const { tempGroupKnowledgeReportData } = api.ihclgetGroupKnowledgeReportData(filterParameters)
//             .then(({ data }) => {
//                 setGroupKnowledgeSessionReportData(data.data)
//                 data.data.forEach(item => {
//                     groupKnowledgeSessionCount += item.sMobile_count || 0;
//                     if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                         groupKnowledgeSessionCountRequested += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "Delivered") {
//                         groupKnowledgeSessionCountDelivered += item.sMobile_count || 0;
//                     }
//                 })

//                 setGroupKnowliedgeData(groupKnowledgeSessionCount)
//                 setGroupKnowledgeSessionRequested(groupKnowledgeSessionCountRequested)
//                 setGroupKnowledgeSessionDelivered(groupKnowledgeSessionCountDelivered)
//             })

//         const { tempExpertConsultaionReportData } = api.ihclgetExpertConsultationReportData(filterParameters)
//             .then(({ data }) => {
//                 data.data.forEach(item => {
//                     expertConsultationCount += item.sMobile_count || 0;

//                     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
//                         expertConsultationCountCancelled += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "") {
//                         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                             item.refSRStateLPM === "Quotation Sent") {
//                             expertConsultationCountRequested += item.sMobile_count || 0;
//                         }

//                         if (item.refSRStateLPM === "Payment Received") {
//                             expertConsultationCountProgress += item.sMobile_count || 0;
//                         }
//                     }

//                     if (item.refCurrentStateSPM !== "") {
//                         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                             expertConsultationCountProgress += item.sMobile_count || 0;
//                         }

//                         if (item.refCurrentStateSPM === "Delivered") {
//                             expertConsultationCountDelivered += item.sMobile_count || 0;
//                         }
//                     }
//                 })

//                 setExpertData(expertConsultationCount);
//                 setExpertConsultationRequested(expertConsultationCountRequested)
//                 setExpertConsultationProgress(expertConsultationCountProgress)
//                 setExpertConsultationDelivered(expertConsultationCountDelivered)
//                 setExpertConsultationCancelled(expertConsultationCountCancelled)
//             })

//         const { tempMarketLinkageData } = api.ihclgetMarketLinkageReportData(filterParameters)
//             .then(({ data }) => {
//                 data.data.forEach(item => {
//                     marketConnectCount += item.sMobile_count || 0;
//                     if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                         marketConnectCountRequested += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "Delivered") {
//                         marketConnectCountDelivered += item.sMobile_count || 0;
//                     }
//                 })

//                 setMarketConnectData(marketConnectCount);
//                 setMarketConnectRequested(marketConnectCountRequested)
//                 setMarketConnectDelivered(marketConnectCountDelivered)
//             })

//         const { tempBlrpReportData } = api.getIhclSocialMediaData(filterParameters)
//             .then(({ data }) => {
//                 data.data.forEach(item => {
//                     blrpCount += item.sMobile_count || 0;

//                     if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
//                         blrpCountCancelled += item.sMobile_count || 0;
//                     }

//                     if (item.refCurrentStateSPM === "") {
//                         if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
//                             item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
//                             item.refSRStateLPM === "Quotation Sent") {
//                             blrpCountRequested += item.sMobile_count || 0;
//                         }

//                         if (item.refSRStateLPM === "Payment Received") {
//                             blrpCountProgress += item.sMobile_count || 0;
//                         }
//                     }

//                     if (item.refCurrentStateSPM !== "") {
//                         if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
//                             blrpCountProgress += item.sMobile_count || 0;
//                         }

//                         if (item.refCurrentStateSPM === "Delivered") {
//                             blrpCountDelivered += item.sMobile_count || 0;
//                         }
//                     }
//                 })

//                 setBlrpData(blrpCount)
//                 setBlrpRequested(blrpCountRequested)
//                 setBlrpProgress(blrpCountProgress)
//                 setSocialMediaDelivered(blrpCountDelivered)
//                 setSocialMediaCancelled(blrpCountCancelled)

//             })


//         const { tempCombineData } = api.ihclmainTableData(filterParameters)
//             .then(({ data }) => {
//                 setCombineData(data)

//                 const ageData = filterAndCombineData(data, 'age')
//                 setAgeWiseData(ageData)

//                 const sectorData = filterAndCombineData(data, 'sBusinessSector')
//                 setSectorWiseData(sectorData)

//                 const BusinessIncData = filterAndCombineData(data, 'sBusinessTurnover')
//                 setBusinessIncData(BusinessIncData)

//                 const FamIncData = filterAndCombineData(data, 'sFamilyIncome')
//                 setFamilyIncData(FamIncData)

//                 const filteredData = data.filter((item) => {
//                     if (item.sResourceDisplayName === 'Shop Act Intimation' || item.sResourceDisplayName === 'Udyam Registration' || item.sResourceDisplayName === 'FSSAI License' || item.sResourceDisplayName === 'Copyright Registration'
//                         || item.sResourceDisplayName === 'Trademark Registration' || item.sResourceDisplayName === 'FSSAI Registration' || item.sResourceDisplayName === 'GST Registration') {
//                         return item;
//                     }
//                 })

//                 // const filteredMarketLinkageData = data.filter((item) => {
//                 //     if (item.sResourceDisplayName === 'Bulk Buyer' || item.sResourceDisplayName === 'Exhibition' || item.sResourceDisplayName === 'Corporate Linkage' || item.sResourceDisplayName === 'Export' || item.sResourceDisplayName === 'Ecommerce' || item.sResourceDisplayName === 'Shop in Shop') {
//                 //         return item
//                 //     }
//                 // })

//                 const filteredMarketLinkageData = data.filter((item) => {
//                     if (item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP' ) {
//                         return item
//                     }
//                 })

//                 setFilteredCompliance(filteredData)
//                 setFilteredMarketLinkage(filteredMarketLinkageData)

//                 setIsLoading(false)
//             })


//     }


//     useEffect(() => {
//         getTableData()
//     }, [])

//     const handleSearch = () => {
//         setAgeWiseData([])
//         setSectorWiseData([])
//         setBusinessIncData([])
//         setFamilyIncData([])
//         setCombineData([])
//         setTotalBeneChartData([])
//         getTableData()
//         setJpmcExpsData([])
//     }

//     const handleClear = () => {
//         setfromDate()
//         settoDate()
//         setAgeWiseData([])
//         setSectorWiseData([])
//         setBusinessIncData([])
//         setFamilyIncData([])
//         setCombineData([])
//         setTotalBeneChartData([])
//         setJpmcExpsData([])
//         setClearClicked(true);
//     }


//     useEffect(() => {
//         if (clearClicked) {
//             getTableData();
//             setClearClicked(false);
//         }
//     }, [clearClicked]);

//     function getCurrentDate() {
//         const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//         const today = new Date();
//         const day = String(today.getDate()).padStart(2, '0');
//         const month = months[today.getMonth()];
//         const year = today.getFullYear();
//         return `${day}${month}${year}`;
//     }

//     const currentDate = getCurrentDate();
//     // const title = `Interested = ${groupKnowledgeSessionRequested}&#10;Attended = ${groupKnowledgeSessionDelivered}`;
//     const title = "Interested:" + groupKnowledgeSessionRequested + "\n" + "Attended:" + groupKnowledgeSessionDelivered


//     return (
//         <div className={`${isLoading && "set-opacity"}`}>
//             {isLoading && <Spinner className="center-screen" />}
//             <div className='row mt-2 ml-1'>
//                 <div className="esp-dashboard-card1 conv-text-center" style={{ height: '38px', paddingleft: '10px', marginRight: "20px" }}>
//                     <label className="esp-box-header-title">Mobilization: {mobilizationCountData || 0}</label>
//                     {/* <h5 className="esp-count-text">{0}</h5> */}
//                     <div style={{ clear: "both" }}></div>

//                 </div>
//                 {/* <div className="col-12"> */}
//                 {/* <div className='col-2'> */}
//                 {/* <a className="con-cursor-pointer"
//                                 href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData ${getCurrentDate()}.xlsx`} download={`JPMCDashboardData ${getCurrentDate()}.xlsx`}>

//                                 <button
//                             className="lpm-con-btn-filled conv-pr35 conv-pl35">
//                             Download CSV
//                         </button>

//                             </a>     */}

//                 <a className="con-cursor-pointer"
//                     href="https://www.deasra.in/program-dashboard/?download_jpmc_program_data=yes" target='_blank'>

//                     <button
//                         className="lpm-con-btn-filled conv-pr35 conv-pl35">
//                         Download CSV
//                     </button>

//                 </a>

//                 {/* <div className='esp-count-text' style={{
//                     border: '1px solid gray',
//                     borderRadius: '2px',
//                     height: 'fit-content',
//                     padding: '5px 28px',
//                     marginLeft: '25px',
//                     marginRight: '10px',
//                     backgroundColor: '#eee'
//                 }}>
//                     Mobilization: <br/>1000
//                 </div> */}


//                 {/* </div> */}

//                 <div className="col-6 ml-1">
//                     <div className="row">
//                         <div className="col-4 spled-container conv-zindex">
//                             <div className="width-100">
//                                 <ReactDatePicker
//                                     dateFormat="dd/MM/yyyy"
//                                     selected={fromDate}
//                                     onChange={(date) => ondatechange("fromDate", date)}
//                                     placeholderText="From Date"
//                                     minDate={new Date("01-01-2024")}
//                                     maxDate={new Date()}
//                                 />
//                             </div>
//                         </div>

//                         <div className="col-4 spled-container conv-zindex">
//                             <div className="width-100">
//                                 <ReactDatePicker
//                                     dateFormat="dd/MM/yyyy"
//                                     selected={toDate}
//                                     onChange={(date) => ondatechange("toDate", date)}
//                                     placeholderText="To Date"
//                                     minDate={new Date("01-01-2024")}
//                                     maxDate={new Date()}
//                                 />
//                             </div>
//                         </div>

//                         <div className="col-4">
//                             <Button className="esp-inline-button mr-2" style={{
//                                 width: "80px", height: '38px'
//                             }} onClick={handleSearch} >Search</Button>
//                             <Button className="esp-inline-button" style={{
//                                 width: '80px', height: '38px'
//                             }} onClick={handleClear} >Clear</Button>
//                         </div>

//                     </div>
//                 </div>

//                 {/* </div> */}



//             </div>

//             <div className="row mb-4">

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                             <label className="esp-box-header-title mt-2">Eligible</label>

//                         {/* <div className='row esp-box-header-title mt-4'>
//                             <div className="col-4"></div>
//                             <div className="col-4">Mobilization</div>
//                             <div className="col-4">Eligible</div>
//                         </div>
//                         <div className='row esp-count-text mt-2'>
//                             <div className="col-4">Target <br/> <span style={{ color: "#78417C" }}>2000</span></div>
//                             <div className="col-4">As on date <br/> <span style={{ color: "#78417C" }}>{mobilizationCountData || 0}</span></div>
//                             <div className="col-4">As on date <br/>
//                             <span style={{ color: "#78417C" }}>
//                                     {countData > 0 ? (
//                                         <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
//                                             {countData}
//                                         </a>
//                                     ) : (
//                                         <span>{countData}</span>
//                                     )}
//                             </span>
//                             </div>/
//                         </div> */}
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>2000</span></h5>
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {countData > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
//                                         {countData}
//                                     </a>
//                                 ) : (
//                                     <span>{countData}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div style={{ justifyContent: 'space-around', padding: "35px" }}></div>
//                         <div className='count-text'>
//                             <span style={{ color: 'lightslategray' }}>
//                                 *The eligible entrepreneurs were identified for further interventions                        </span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff"
//                         height: "220px",
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${groupknowledgesession}`} download={`Group Knowledge Session ${getCurrentDate()}.xlsx`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Group Knowledge Session</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>1500</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{groupKnowledgeData || 0}</span></h5> */}
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>
//                                 <a className="con-cursor-pointer" style={{ color: "#78417C" }}
//                                     href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData.xlsx`} download="JPMCDashboardData.xlsx">
//                                     {groupKnowledgeData || 0}
//                                 </a>
//                             </span>
//                             </h5> */}
//                             <h5 className="esp-count-text"
//                             //  title='Requested = 10&#10;In Progress = 3&#10;Delivered = 10'
//                             // title={title}

//                             >As on Date <br /> <span style={{ color: "#78417C" }}>
//                                     {groupKnowledgeSessionDelivered > 0 ? (
//                                         <>
//                                             <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/GroupKnowledgeSession ${getCurrentDate()}.xlsx`} download={`GroupKnowledgeSession ${getCurrentDate()}.xlsx`}>
//                                                 {/* {groupKnowledgeData} */}
//                                                 {groupKnowledgeSessionDelivered}
//                                             </a>
//                                         </>
//                                     ) : (
//                                         <span>{groupKnowledgeSessionDelivered}</span>
//                                     )}
//                                 </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Interested <br /> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionRequested}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Attended <br/> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionDelivered}</span></h5> */}
//                         </div>
//                         <div className='count-text'>
//                             <span style={{ color: 'lightslategray' }}>
//                                 *Remaining women entrepreneurs could not attend the session due to various reasons
//                             </span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${expertconsultation}`} download={`Expert Consultation ${getCurrentDate()}.xlsx`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Expert Consultation</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>800</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{expertData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {expertConsultationDelivered > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/ExpertConsultation ${getCurrentDate()}.xlsx`} download={`ExpertConsultation ${getCurrentDate()}.xlsx`}>
//                                         {/* {expertData} */}
//                                         {expertConsultationDelivered}
//                                     </a>
//                                 ) : (
//                                     // <span>{expertData}</span>
//                                     <span>{expertConsultationDelivered}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Requested <br /> <span style={{ color: "#78417C" }}>{expertConsultationRequested}</span></h5> */}
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Interested <br /> <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered <br/> <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
//                         </div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="row mt-2 mb-4">
//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${marketlinkagesession}`} download={`Market Connect ${getCurrentDate()}.xlsx`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Market Connect</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>500</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{marketConnectData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {marketConnectDelivered > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/MarketConnect ${getCurrentDate()}.xlsx`} download={`MarketConnect ${getCurrentDate()}.xlsx`}>
//                                         {/* {marketConnectData} */}
//                                         {marketConnectDelivered}
//                                     </a>
//                                 ) : (
//                                     <span>{marketConnectDelivered}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Interested<br /> <span style={{ color: "#78417C" }}>{marketConnectRequested}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Opportunities Availed<br/> <span style={{ color: "#78417C" }}>{marketConnectDelivered}</span></h5> */}
//                         </div>
//                         <div className='count-text'>
//                             <span style={{ color: 'lightslategray' }}>
//                                 *Remaining women entrepreneurs could not avail the market opportunities due to some reasons
//                             </span>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${compliancesession}`} download={`Compliance ${getCurrentDate()}.xlsx`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Compliance</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>100</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{complianceData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {complianceDelivered > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Compliance ${getCurrentDate()}.xlsx`} download={`Compliance ${getCurrentDate()}.xlsx`}>
//                                         {/* {complianceData} */}
//                                         {complianceDelivered}
//                                     </a>
//                                 ) : (
//                                     <span>{complianceDelivered}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         {/* <div style={{ clear: "both" }}></div> */}
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Requested <br /> <span style={{ color: "#78417C" }}>{complianceRequested}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress <br /> <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered <br/> <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
//                         </div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Cancelled: <span style={{ color: "#78417C" }}>{complianceCancellled}</span></h5> */}
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress: <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered: <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-4">
//                     <div style={{
//                         backgroundColor: '#eee',
//                         // color: "#fff",
//                         height: '220px'
//                     }} className="esp-dashboard-card conv-text-center w-100"
//                     // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
//                     >
//                         <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${blrpsession}`} download={`Business Loan Readiness Program ${getCurrentDate()}.xlsx`}>
//                             <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Business Loan Readiness Program</label>
//                         </a>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
//                             <h5 className="esp-count-text">Target <br /><span style={{ color: "#78417C" }}>100</span></h5>
//                             {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{blrpData || 0}</span></h5> */}
//                             <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
//                                 {socialMediaDelivered > 0 ? (
//                                     <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/BLRP ${getCurrentDate()}.xlsx`} download={`BLRP ${getCurrentDate()}.xlsx`}>
//                                         {/* {blrpData} */}
//                                         {socialMediaDelivered}
//                                     </a>
//                                 ) : (
//                                     <span>{socialMediaDelivered}</span>
//                                 )}
//                             </span>
//                             </h5>
//                         </div>
//                         <div style={{ clear: "both" }}></div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Requested <br /> <span style={{ color: "#78417C" }}>{blrpRequested}</span></h5> */}
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Interested <br /> <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered <br/> <span style={{ color: "#78417C" }}>{socialMediaDelivered}</span></h5> */}
//                         </div>
//                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Cancelled: <span style={{ color: "#78417C" }}>{socialMediaCancelled}</span></h5> */}
//                             {/* <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>In Progress: <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
//                             <h5 className="count-text" style={{
//                                 color: '#000'
//                             }}>Delivered: <span style={{ color: "#78417C" }}>{socialMediaDelivered}</span></h5> */}
//                         </div>
//                     </div>
//                 </div>

//             </div>

//             {/* <div className='row mb-3 text-center'>
//                 <div className='col-12'>
//                     <div className='esp-count-text'>
//                         <span style={{color: 'red'}}>
//                         Note: The number indicates both, the services in progress and delivered.
//                         </span>
//                     </div>
//                 </div>
//             </div> */}

//             <div style={{
//                 borderBottom: "2px solid lightgray"
//             }}></div>

//             <div className="row mt-3 mb-2">
//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     <HistogramTotalBeneficiaryChart isLoading={isLoading} data={totalBeneChartData} />
//                 </div>

//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     <DeliveredResourcePieChart data={summaryData} />
//                 </div>
//             </div>

//             {/* <div className="row mt-3 mb-2">
//                 <div className="col-6">
//                     <DataPieChart data={combineData}/> 
//                 </div>

//                 <div className="col-6">
//                     <CustomHistogramChart isLoading={isLoading} data={combineData}/> 
//                 </div>
//             </div> */}

//             <div className="row mt-3 mb-2">
//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     {/* <DataPieChart data={combineData}/>  */}
//                     <CompliancePieChart data={filteredCompliance} />
//                 </div>

//                 <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
//                     <MarketLinkagePieChart data={filteredMarketLinkage} />
//                     {/* <CustomHistogramChart isLoading={isLoading} data={combineData}/>  */}
//                 </div>
//             </div>

//             <div className="row mt-3 mb-2">
//                 <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
//                     {/* <DataPieChart data={combineData}/>  */}
//                     {/* <CompliancePieChart data={filteredCompliance} /> */}
//                     <KnowledgeSessionPieChart data={combineData} />
//                 </div>
//             </div>

//             {
//                 loadMore &&
//                 <>
//                     <div className="row mt-2 mb-2">
//                         <div className="col-md-12">
//                             <IhclMainTable isLoading={isLoading} data={combineData} />
//                         </div>
//                     </div>

//                     <div className="row mt-2 mb-2">
//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <AgeWiseIhclTable isLoading={isLoading} data={ageWiseData} />
//                         </div>

//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <IncomeIhclTable isLoading={isLoading} data={businessIncData} />
//                         </div>
//                     </div>

//                     <div className="row mt-2 mb-4">
//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <SectorWiseIhclTable isLoading={isLoading} data={sectorWiseData} />
//                         </div>

//                         <div className="col-lg-6 col-md-12 col-sm-12">
//                             <FamilyIncomeIhclTable isLoading={isLoading} data={familyIncData} />
//                         </div>
//                     </div>

//                     {/* <div className="row mt-2 mb-4">
//                         <div className="col-md-12">
//                             <IhclExpenseTable isLoading={isLoading} data={jpmcExpsData} />
//                         </div>
//                     </div> */}
//                 </>
//             }

//             {
//                 !loadMore &&
//                 <div className='d-flex justify-content-center mt-2 mb-3'>
//                     <button className="my-services-model-cancel-btn" onClick={() => setLoadMore(true)} >Load More</button>
//                 </div>
//             }

//         </div>
//     )
// }

// export default IhclDashboardContainer




////////////////////////////////////////////////////////////////
//////////////////////// BELOW IS ORIGINAL /////////////////////
////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from 'react'
import ReactDatePicker from "react-datepicker";
import { Button } from "../../common/Button/Button";

import IhclMainTable from './IhclMainTable';

import AgeWiseIhclTable from './AgeWiseIhclTable';

import SectorWiseIhclTable from './SectorWiseIhclTable';

import FamilyIncomeIhclTable from './FamilyIncomeIhclTable';

import IncomeIhclTable from './IncomeIhclTable';

import api from '../../utils/api';
import Spinner from '../../common/Spinner/Spinner';
import DataPieChart from './DataPieChart';
import CustomHistogramChart from './CustomHistogramChart';
import HistogramTotalBeneficiaryChart from './HistogramTotalBeneficiaryChart';
import CompliancePieChart from './CompliancePieChart';
import MarketLinkagePieChart from './MarketLinkagePieChart';
import DeliveredResourcePieChart from './DeliveredResourcePieChart';
import { toast } from 'react-toastify';

import IhclExpenseTable from './IhclExpenseTable';

import { DOWNLOAD_API_URL } from '../../utils/constants';
import KnowledgeSessionPieChart from './KnowledgeSessionPieChart';
import { Info } from 'react-feather';

import { getUser } from '../../utils/localStorage';
import MarketingPieChart from './MarketingPieChart';



const IhclDashboardContainer = () => {

    const [fromDate, setfromDate] = useState();
    const [toDate, settoDate] = useState();
    const [ageWiseData, setAgeWiseData] = useState([])
    const [sectorWiseData, setSectorWiseData] = useState([])
    const [familyIncData, setFamilyIncData] = useState([])
    const [businessIncData, setBusinessIncData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [clearClicked, setClearClicked] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [countData, setCountData] = useState("")
    const [mobilizationCountData, setMobilizationCountData] = useState("")
    const [totalBeneChartData, setTotalBeneChartData] = useState([])
    const [groupKnowledgeData, setGroupKnowliedgeData] = useState()
    const [expertData, setExpertData] = useState()
    const [marketConnectData, setMarketConnectData] = useState()
    const [complianceData, setComplianceData] = useState()
    const [blrpData, setBlrpData] = useState()
    const [loadMore, setLoadMore] = useState(false)
    const [filteredCompliance, setFilteredCompliance] = useState([])
    const [filteredMarketLinkage, setFilteredMarketLinkage] = useState([])
    const [summaryData, setSummaryData] = useState([])
    const [jpmcExpsData, setJpmcExpsData] = useState([])

    const [complianceReportData, setComplianceReportData] = useState()
    const [groupKnowledgeSessionReportData, setGroupKnowledgeSessionReportData] = useState()

    const [complianceRequested, setComplianceRequested] = useState()
    const [complianceProgress, setComplianceProgress] = useState()
    const [complianceDelivered, setComplianceDelivered] = useState()
    const [complianceCancellled, setComplianceCancelled] = useState()
    const [complianceDeliveredCountFromApi, setComplianceDeliveredCountFromApi] = useState(0);

    const [groupKnowledgeSessionRequested, setGroupKnowledgeSessionRequested] = useState()
    const [groupKnowledgeSessionProgress, setGroupKnowledgeSessionProgress] = useState()
    const [groupKnowledgeSessionDelivered, setGroupKnowledgeSessionDelivered] = useState(0)
    const [groupKnowledgeSessionCountFromApi, setGroupKnowledgeSessionCountFromAPi] = useState(0);

    const [expertConsultationRequested, setExpertConsultationRequested] = useState()
    const [expertConsultationProgress, setExpertConsultationProgress] = useState()
    const [expertConsultationDelivered, setExpertConsultationDelivered] = useState()
    const [experConsultationCancelled, setExpertConsultationCancelled] = useState()
    const [expertConsultationCountFromAPi, setExpertConsultationCountFromApi] = useState(0);

    const [marketConnectRequested, setMarketConnectRequested] = useState()
    const [marketConnectProgress, setMarketConnectProgress] = useState()
    const [marketConnectDelivered, setMarketConnectDelivered] = useState()
    const [marketConnectCountFromAPi, setMarketConnectCountFromApi] = useState(0);

    const [blrpRequested, setBlrpRequested] = useState()
    const [blrpProgress, setBlrpProgress] = useState()
    const [socialMediaDelivered, setSocialMediaDelivered] = useState()
    const [socialMediaCancelled, setSocialMediaCancelled] = useState()
    const [socialMediaCountFromApi, setSocialMediaCountFromApi] = useState(0);
    const [marketingPieChartData, setMarketingPieChartData] = useState([])

    const [groupknowledgesession, setgroupknowledgesession] = useState([])
    const [groupKnowledgeSessionAsOnFileName, setGroupKnowledgeSessionAsOnFileName] = useState([]);
    const [marketlinkagesession, setmarketlinkagesession] = useState([])
    const [marketlinkagesessionAsOnFileName, setMarketlinkagesessionAsOnFileName] = useState([])
    const [compliancesession, setcompliancesession] = useState([])
    const [compliancesessionAsOnFileName, setCompliancesessionAsOnFileName] = useState([]);
    const [expertconsultation, setexpertconsultation] = useState([])
    const [expertConsultationAsOnFilename, setExpertConsultationAsOnFilename] = useState([])
    const [socialMediaSession, setSocialMediaSession] = useState([])
    const [socialMediaSessionAsOnFileName, setSocialMediaSessionAsOnFileName] = useState([]);
    

    const [eligibleAsOnDate, setEligibleAsOnDate] = useState(0);
    
    const [rolesPermissions, setRolesPermissions] = useState()

    useEffect(() => {
        const mobileWidthBreakpoint = 768;
        const displayToastForMobileResolution = () => {
            if (window.innerWidth < mobileWidthBreakpoint) {
                toast("This dashboard is best viewable in a desktop browser.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        };

        const user = getUser();
        console.log(user?.role, ">>>> user in IHCL dashboard use effect");
        setRolesPermissions(user?.role);
        

        displayToastForMobileResolution();

        window.addEventListener('resize', displayToastForMobileResolution);

        return () => window.removeEventListener('resize', displayToastForMobileResolution);
    }, []);

    const ondatechange = (key, date) => {
        if (key === "fromDate") {
            setfromDate(date)

        } else if (key === "toDate") {
            settoDate(date)

        }
    };

    const dateAdjusted = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const dateAdjusted1 = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const filterAndCombineData = (data, keyToCompare) => {
        const combinedData = {};

        data.forEach(entry => {
            const key = `${entry[keyToCompare]}_${entry.sResourceDisplayName}`;

            if (combinedData[key]) {
                combinedData[key].sMobile_count += entry.sMobile_count;
            } else {
                combinedData[key] = { ...entry };
            }
        });

        const combinedDataArray = Object.values(combinedData);

        return combinedDataArray;
    };

    useEffect(() => {
        setSummaryData([
            ["Expert Consultation", expertConsultationCountFromAPi],
            ["Market Connect", marketConnectCountFromAPi],
            ["Group Knowledge Session", groupKnowledgeSessionCountFromApi],
            ["Marketing", socialMediaDelivered],
            ["Compliance", complianceDeliveredCountFromApi]
        ])
    }, [groupKnowledgeSessionDelivered, complianceDelivered, expertConsultationDelivered, marketConnectDelivered, socialMediaDelivered])

    const getTableData = () => {
        let filterParameters = {}

        if (fromDate) {
            filterParameters.fromDate = dateAdjusted1(fromDate)
        }

        if (toDate) {
            filterParameters.toDate = dateAdjusted(toDate)
        }

        console.log("Filter", filterParameters)
        setIsLoading(true)

        let payload = {
            // api_key : "r54B?rHXUE7v%$9t",
            api_key: "82mqEyJnct4kzC8y",

        }

        const { tempMobilizationCount } = api.ihclmobilizationCountApi(payload)
            .then(({ data }) => {
                // setMobilizationCountData(data.data.total_count)
                setMobilizationCountData(data)
                setEligibleAsOnDate(data)
            }).catch(err=>{
                console.log(err, ">>>err");
            })

        const { tempCountData } = api.ihclCountData(filterParameters)
            .then(({ data }) => {
                console.log("COUNT", data.count)
                setCountData(data.count)
            })
            .catch(err=>{
                console.log(err);
            })

        const { tempTotalBeneficiaryData } = api.ihcltotalBeneficiaryChartData(filterParameters)
            .then(({ data }) => {
                console.log("Chart Data", data)
                setTotalBeneChartData(data)
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempJpmcExpenseData } = api.jpmcExpenseTableData(filterParameters)
            .then(({ data }) => {
                console.log("Expense Data", data)
                setJpmcExpsData(data.data)
            })
            .catch(err=>{
                console.log(err,">>>err");
                
            })

        const { tempComplianceReport } = api.ihclgetComplianceReportAPI(filterParameters)
            .then(({ data }) => {
                console.log("Data Report Compliance", data)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setCompliancesessionAsOnFileName(`${filename}`);
            })
            .catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempExpertConsultaionReport } = api.ihclgetExpertConsultationReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Report Expert", data)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];
                console.log(filename, ">>>filename of expert consultation as on date");
                
                setExpertConsultationAsOnFilename(`${filename}`);
                
            }).catch(err=>{
                console.log(err,">>>err")
                
            })
            

        const { tempMobilizationReport } = api.ihclgetMobilizationReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Report Mobilization", data)
            })
            .catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempBlrpReport } = api.ihclgetIhclSocialMediaReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Report blrp", data)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];
                
                setSocialMediaSessionAsOnFileName(`${filename}`);
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempGroupKnowledgeReport } = api.ihclgetGroupKnowledgeReport(filterParameters)
            .then(({ data }) => {
                console.log(">>>Data Report Groupknowledge", data)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];
                console.log(filename, ">>>filename of grop knowledgesession as on date");
                
                setGroupKnowledgeSessionAsOnFileName(`${filename}`);
            })
            .catch(err=> {
                console.log(err, ">>>err")
                
            })

        const { tempGroupKnowledgeSessionReport } = api.ihclgetGroupKnowledgeSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setgroupknowledgesession(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempMarketLinkageSessionReport } = api.ihclgetMarketLinkageSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setmarketlinkagesession(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempComplianceSessionReport } = api.ihclgetComplianceSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setcompliancesession(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempExpertConsultationSessionReport } = api.ihclgetExpertConsultationSessionReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setexpertconsultation(`${filename}`);

                // console.log("Generated File Path:", `${filename}`);
            }).catch(err=>{
                console.log(err,">>err")
                
            })

        const { tempblrpSessionReport } = api.ihclgetSocialMediaAllData(filterParameters)
            .then(({ data }) => {
                console.log("Data Group Knowledge Session Report", data);
                console.log("filterParameters", filterParameters)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setSocialMediaSession(`${filename}`);

                console.log("Generated File Path:", `/${filename}`);
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })




        const { tempMarketLinkage } = api.ihclgetMarketLinkageReport(filterParameters)
            .then(({ data }) => {
                console.log("Data Report MarketLinkage", data)
                const fullPath = data.generated_file;
                const parts = fullPath.split('/');
                const filename = parts[parts.length - 1];

                setMarketlinkagesessionAsOnFileName(`${filename}`);
            }).catch(err=>{
                console.log(err,">>>");
                
            })

        const { tempJpmcAllData } = api.getIhclAllData(filterParameters)
            .then(({ data }) => {
                console.log("Data Report All", data);
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })

        let complianceCount = 0;
        let complianceCountDelivered = 0;
        let complianceCountRequested = 0;
        let complianceCountProgress = 0;
        let complianceCountCancelled = 0;

        let groupKnowledgeSessionCount = 0;
        let groupKnowledgeSessionCountDelivered = 0;
        let groupKnowledgeSessionCountRequested = 0;
        let groupKnowledgeSessionCountProgress = 0;
        let groupKnowledgeSessionCountCancelled = 0;

        let expertConsultationCount = 0;
        let expertConsultationCountDelivered = 0;
        let expertConsultationCountRequested = 0;
        let expertConsultationCountProgress = 0;
        let expertConsultationCountCancelled = 0;

        let marketConnectCount = 0;
        let marketConnectCountDelivered = 0;
        let marketConnectCountRequested = 0;
        let marketConnectCountProgress = 0;
        let marketConnectCountCancelled = 0;

        let blrpCount = 0;
        let blrpCountDelivered = 0;
        let blrpCountRequested = 0;
        let blrpCountProgress = 0;
        let blrpCountCancelled = 0;

        let generatedFilePath;



        const { tempComplianceReportData } = api.ihclgetComplianceReportDataAPI(filterParameters)
            .then(({ data }) => {
                console.log("ComplianceData", data)
                setComplianceReportData(data.data)
                setComplianceDeliveredCountFromApi(data?.count);
                data.data.forEach(item => {
                    complianceCount += item.sMobile_count || 0;

                    if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                        complianceCountCancelled += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "") {
                        if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
                            item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
                            item.refSRStateLPM === "Quotation Sent") {
                            complianceCountRequested += item.sMobile_count || 0;
                        }

                        if (item.refSRStateLPM === "Payment Received") {
                            complianceCountProgress += item.sMobile_count || 0;
                        }
                    }

                    if (item.refCurrentStateSPM !== "") {
                        if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                            complianceCountProgress += item.sMobile_count || 0;
                        }

                        if (item.refCurrentStateSPM === "Delivered") {
                            complianceCountDelivered += item.sMobile_count || 0;
                        }
                    }
                })

                setComplianceDelivered(complianceCountDelivered)
                setComplianceRequested(complianceCountRequested)
                setComplianceProgress(complianceCountProgress)
                setComplianceCancelled(complianceCountCancelled)
                setComplianceData(complianceCount)
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempGroupKnowledgeReportData } = api.ihclgetGroupKnowledgeReportData(filterParameters)
            .then(({ data }) => {
                setGroupKnowledgeSessionReportData(data.data)
                setGroupKnowledgeSessionCountFromAPi(data?.count);

                data.data.forEach(item => {
                    groupKnowledgeSessionCount += item.sMobile_count || 0;
                    if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                        groupKnowledgeSessionCountRequested += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "Delivered") {
                        groupKnowledgeSessionCountDelivered += item.sMobile_count || 0;
                    }
                })

                setGroupKnowliedgeData(groupKnowledgeSessionCount)
                setGroupKnowledgeSessionRequested(groupKnowledgeSessionCountRequested)
                setGroupKnowledgeSessionDelivered(groupKnowledgeSessionCountDelivered)
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempExpertConsultaionReportData } = api.ihclgetExpertConsultationReportData(filterParameters)
            .then(({ data }) => {
                setExpertConsultationCountFromApi(data?.count)
                data.data.forEach(item => {
                    expertConsultationCount += item.sMobile_count || 0;

                    if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                        expertConsultationCountCancelled += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "") {
                        if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
                            item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
                            item.refSRStateLPM === "Quotation Sent") {
                            expertConsultationCountRequested += item.sMobile_count || 0;
                        }

                        if (item.refSRStateLPM === "Payment Received") {
                            expertConsultationCountProgress += item.sMobile_count || 0;
                        }
                    }

                    if (item.refCurrentStateSPM !== "") {
                        if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                            expertConsultationCountProgress += item.sMobile_count || 0;
                        }

                        if (item.refCurrentStateSPM === "Delivered") {
                            expertConsultationCountDelivered += item.sMobile_count || 0;
                        }
                    }
                })

                setExpertData(expertConsultationCount);
                setExpertConsultationRequested(expertConsultationCountRequested)
                setExpertConsultationProgress(expertConsultationCountProgress)
                setExpertConsultationDelivered(expertConsultationCountDelivered)
                setExpertConsultationCancelled(expertConsultationCountCancelled)
            }).catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempMarketLinkageData } = api.ihclgetMarketLinkageReportData(filterParameters)
            .then(({ data }) => {
                setMarketConnectCountFromApi(data?.count);

                data.data.forEach(item => {
                    marketConnectCount += item.sMobile_count || 0;
                    if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                        marketConnectCountRequested += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "Delivered") {
                        marketConnectCountDelivered += item.sMobile_count || 0;
                    }
                })

                setMarketConnectData(marketConnectCount);
                setMarketConnectRequested(marketConnectCountRequested)
                setMarketConnectDelivered(marketConnectCountDelivered)
            })
            .catch(err=>{
                console.log(err, ">>>err");
                
            })

        const { tempBlrpReportData } = api.getIhclSocialMediaData(filterParameters)
            .then(({ data }) => {
                setSocialMediaCountFromApi(data?.count)
                data.data.forEach(item => {
                    blrpCount += item.sMobile_count || 0;

                    if (item.refSRStateLPM === "Cancelled" || item.refCurrentStateSPM === "Cancelled") {
                        blrpCountCancelled += item.sMobile_count || 0;
                    }

                    if (item.refCurrentStateSPM === "") {
                        if (item.refSRStateLPM === "Requested" || item.refSRStateLPM === "Eligible" ||
                            item.refSRStateLPM === "Prepared" || item.refSRStateLPM === "Partial/ Full Payment Pending" ||
                            item.refSRStateLPM === "Quotation Sent") {
                            blrpCountRequested += item.sMobile_count || 0;
                        }

                        if (item.refSRStateLPM === "Payment Received") {
                            blrpCountProgress += item.sMobile_count || 0;
                        }
                    }

                    if (item.refCurrentStateSPM !== "") {
                        if (item.refCurrentStateSPM !== "Delivered" && item.refCurrentStateSPM !== "Cancelled") {
                            blrpCountProgress += item.sMobile_count || 0;
                        }

                        if (item.refCurrentStateSPM === "Delivered") {
                            blrpCountDelivered += item.sMobile_count || 0;
                        }
                    }
                })

                setBlrpData(blrpCount)
                setBlrpRequested(blrpCountRequested)
                setBlrpProgress(blrpCountProgress)
                setSocialMediaDelivered(blrpCountDelivered)
                setSocialMediaCancelled(blrpCountCancelled)

            }).catch(err=>{
                console.log(err, ">>>err");
                
            })


        const { tempCombineData } = api.ihclmainTableData(filterParameters)
            .then(({ data }) => {
                setCombineData(data)

                const ageData = filterAndCombineData(data, 'age')
                setAgeWiseData(ageData)

                const sectorData = filterAndCombineData(data, 'sBusinessSector')
                setSectorWiseData(sectorData)

                const BusinessIncData = filterAndCombineData(data, 'sBusinessTurnover')
                setBusinessIncData(BusinessIncData)

                const FamIncData = filterAndCombineData(data, 'sFamilyIncome')
                setFamilyIncData(FamIncData)

                const filteredData = data.filter((item) => {
                    if (item.sResourceDisplayName === 'Shop Act Intimation' || item.sResourceDisplayName === 'Udyam Registration' || item.sResourceDisplayName === 'FSSAI License' || item.sResourceDisplayName === 'Copyright Registration'
                        || item.sResourceDisplayName === 'Trademark Registration' || item.sResourceDisplayName === 'FSSAI Registration' || item.sResourceDisplayName === 'GST Registration') {
                        return item;
                    }
                })

                // const filteredMarketLinkageData = data.filter((item) => {
                //     if (item.sResourceDisplayName === 'Bulk Buyer' || item.sResourceDisplayName === 'Exhibition' || item.sResourceDisplayName === 'Corporate Linkage' || item.sResourceDisplayName === 'Export' || item.sResourceDisplayName === 'Ecommerce' || item.sResourceDisplayName === 'Shop in Shop') {
                //         return item
                //     }
                // })

                const filteredMarketLinkageData = data.filter((item) => {
                    if (item.sResourceID === 'MKTLINKAGECORPLINKAGE' || item.sResourceID === 'MKTLINKAGEEXHIBITION' || item.sResourceID === 'MKTLINKAGEBULKBUYER' || item.sResourceID === 'MKTLINKAGEEXPORT' || item.sResourceID === 'MKTLINKAGEECOM' || item.sResourceID === 'MKTLINKAGESHOPINSHOP' ) {
                        return item
                    }
                })

                const marketingData = data.filter((item) => {
                    if(item.sResourceID === "GOONLINE" || item.sResourceID === "SOCIALMEDIAMGMT"){
                        return item;
                    }
                })

                setFilteredCompliance(filteredData)
                setFilteredMarketLinkage(filteredMarketLinkageData)
                setMarketingPieChartData(marketingData)

                setIsLoading(false)
            }).catch(err=>{
                console.log(err, ">>>err");
                setIsLoading(false)
            })

            // setIsLoading(false)
    }


    useEffect(() => {
        getTableData()
    }, [])

    const handleSearch = () => {
        setAgeWiseData([])
        setSectorWiseData([])
        setBusinessIncData([])
        setFamilyIncData([])
        setCombineData([])
        setTotalBeneChartData([])
        getTableData()
        setJpmcExpsData([])
    }

    const handleClear = () => {
        setfromDate()
        settoDate()
        setAgeWiseData([])
        setSectorWiseData([])
        setBusinessIncData([])
        setFamilyIncData([])
        setCombineData([])
        setTotalBeneChartData([])
        setJpmcExpsData([])
        setClearClicked(true);
    }


    useEffect(() => {
        if (clearClicked) {
            getTableData();
            setClearClicked(false);
        }
    }, [clearClicked]);

    function getCurrentDate() {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = months[today.getMonth()];
        const year = today.getFullYear();
        return `${day}${month}${year}`;
    }

    const currentDate = getCurrentDate();
    // const title = `Interested = ${groupKnowledgeSessionRequested}&#10;Attended = ${groupKnowledgeSessionDelivered}`;
    const title = "Interested:" + groupKnowledgeSessionRequested + "\n" + "Attended:" + groupKnowledgeSessionDelivered


    console.log(groupknowledgesession, ">>>groupknowledgesession all in ihcl");
    console.log(groupKnowledgeSessionAsOnFileName, ">>>> group knowlegde name for as on date");
    console.log(expertConsultationAsOnFilename, ">>>>expertConsultationAsOnFilename for as on date");
    console.log(marketlinkagesessionAsOnFileName, ">>>>marketlinkagesessionAsOnFileName for as on date ");
    console.log(compliancesessionAsOnFileName, ">>>>compliancesessionAsOnFileName for a on date");
    console.log(socialMediaSessionAsOnFileName, ">>>socialMediaSessionAsOnFileName for as on date");
    console.log(summaryData, ">>>>summaryData");
    console.log(expertConsultationDelivered, ">>>>>expertConsultationDelivered")
    return (
        rolesPermissions?.includes(16)?(
            <div className={`${isLoading && "set-opacity"}`}>
            {isLoading && <Spinner className="center-screen" />}
            <div className='row mt-2 ml-1'>
                <div className="esp-dashboard-card1 conv-text-center" style={{ height: '38px', paddingleft: '10px', marginRight: "20px" }}>
                    {/* <label className="esp-box-header-title">Mobilization: {mobilizationCountData || 0}</label> */}
                    {/* <h5 className="esp-count-text">{0}</h5> */}
                    <label className="esp-box-header-title">Mobilization: {mobilizationCountData || 0}</label>
                    <div style={{ clear: "both" }}></div>

                </div>
                {/* <div className="col-12"> */}
                {/* <div className='col-2'> */}
                {/* <a className="con-cursor-pointer"
                                href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData ${getCurrentDate()}.xlsx`} download={`JPMCDashboardData ${getCurrentDate()}.xlsx`}>

                                <button
                            className="lpm-con-btn-filled conv-pr35 conv-pl35">
                            Download CSV
                        </button>

                            </a>     */}

                <a className="con-cursor-pointer"
                    // href="https://www.deasra.in/program-dashboard/?download_jpmc_program_data=yes" target='_blank'>
                    href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible_IHCL ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
                    <button
                        className="lpm-con-btn-filled conv-pr35 conv-pl35">
                        Download CSV
                    </button>

                </a>

                {/* <div className='esp-count-text' style={{
                    border: '1px solid gray',
                    borderRadius: '2px',
                    height: 'fit-content',
                    padding: '5px 28px',
                    marginLeft: '25px',
                    marginRight: '10px',
                    backgroundColor: '#eee'
                }}>
                    Mobilization: <br/>1000
                </div> */}


                {/* </div> */}

                <div className="col-6 ml-1">
                    <div className="row">
                        <div className="col-4 spled-container conv-zindex">
                            <div className="width-100">
                                <ReactDatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={fromDate}
                                    onChange={(date) => ondatechange("fromDate", date)}
                                    placeholderText="From Date"
                                    minDate={new Date("01-01-2024")}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>

                        <div className="col-4 spled-container conv-zindex">
                            <div className="width-100">
                                <ReactDatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={toDate}
                                    onChange={(date) => ondatechange("toDate", date)}
                                    placeholderText="To Date"
                                    minDate={new Date("01-01-2024")}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>

                        <div className="col-4">
                            <Button className="esp-inline-button mr-2" style={{
                                width: "80px", height: '38px'
                            }} onClick={handleSearch} >Search</Button>
                            <Button className="esp-inline-button" style={{
                                width: '80px', height: '38px'
                            }} onClick={handleClear} >Clear</Button>
                        </div>

                    </div>
                </div>

                {/* </div> */}



            </div>

            <div className="row mb-4">

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                            <label className="esp-box-header-title mt-2">Eligible</label>

                        {/* <div className='row esp-box-header-title mt-4'>
                            <div className="col-4"></div>
                            <div className="col-4">Mobilization</div>
                            <div className="col-4">Eligible</div>
                        </div>
                        <div className='row esp-count-text mt-2'>
                            <div className="col-4">Target <br/> <span style={{ color: "#78417C" }}>2000</span></div>
                            <div className="col-4">As on date <br/> <span style={{ color: "#78417C" }}>{mobilizationCountData || 0}</span></div>
                            <div className="col-4">As on date <br/>
                            <span style={{ color: "#78417C" }}>
                                    {countData > 0 ? (
                                        <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
                                            {countData}
                                        </a>
                                    ) : (
                                        <span>{countData}</span>
                                    )}
                            </span>
                            </div>/
                        </div> */}
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
                            <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>20</span></h5>
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {eligibleAsOnDate > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible_IHCL ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
                                       {eligibleAsOnDate}
                                    </a>
                                    // <span>{20}</span>
                                ) : (
                                    <span>{0}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div style={{ justifyContent: 'space-around', padding: "35px" }}></div>
                        {/*<div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *The eligible entrepreneurs were identified for further interventions                        </span>
                        </div>*/}
                    </div>
                </div>

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff"
                        height: "220px",
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${groupknowledgesession}`} download={`${groupknowledgesession}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Group Knowledge Session</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px', backgroundColor:"" }}>
                            <h5 className="esp-count-text" style={{backgroundColor:""}}>Target <br /> <span className='boxCardTextStyle' style={{ color: "#78417C"}}>{2*20}<span className='astrixStyle' style={{marginTop:"-5px"}}>*</span></span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{groupKnowledgeData || 0}</span></h5> */}
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>
                                <a className="con-cursor-pointer" style={{ color: "#78417C" }}
                                    href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData.xlsx`} download="JPMCDashboardData.xlsx">
                                    {groupKnowledgeData || 0}
                                </a>
                            </span>
                            </h5> */}
                            <h5 className="esp-count-text"
                            //  title='Requested = 10&#10;In Progress = 3&#10;Delivered = 10'
                            // title={title}

                            >As on Date <br /> <span style={{ color: "#78417C" }}>
                                    {groupKnowledgeSessionCountFromApi > 0 ? (
                                        <>
                                            <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${groupKnowledgeSessionAsOnFileName}`} download={`${groupKnowledgeSessionAsOnFileName}`}>
                                                {/* {// {groupKnowledgeData} //} */}
                                                {groupKnowledgeSessionCountFromApi}
                                            </a>
                                            {/* <span>{0}</span> */}
                                        </>
                                    ) : (
                                        <span>{groupKnowledgeSessionCountFromApi}</span>
                                    )}
                                </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested <br /> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Attended <br/> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *2 Group knowledge sessions per 20 entrepreneurs
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${expertconsultation}`} download={`${expertconsultation}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Expert Consultation</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
                            <h5 className="esp-count-text">Target <br /> <span className='boxCardTextStyle' style={{ color: "#78417C" }}>{3*20}<span className='astrixStyle' style={{marginTop:"-5px"}}>*</span></span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{expertData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {expertConsultationCountFromAPi > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${expertConsultationAsOnFilename}`} download={`${expertConsultationAsOnFilename}`}>
                                        {expertConsultationCountFromAPi}
                                        {/* {expertConsultationDelivered} */}
                                    </a>
                                ) : (
                                    // <span>{expertData}</span>
                                    <span>{expertConsultationCountFromAPi}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{expertConsultationRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested <br /> <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *3 one-on-one sessions per 20 entrepreneurs
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-2 mb-4">
                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${marketlinkagesession}`} download={`${marketlinkagesession}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Market Connect</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            <h5 className="esp-count-text">Target <br /> <span className='boxCardTextStyle' style={{ color: "#78417C" }}>{2*20} <span className='astrixStyle' style={{marginTop:"-5px"}}>*</span></span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{marketConnectData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {marketConnectCountFromAPi > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${marketlinkagesessionAsOnFileName}`} download={`${marketlinkagesessionAsOnFileName}`}>
                                        {/* {marketConnectData} */}
                                        {marketConnectCountFromAPi}
                                    </a>
                                ) : (
                                    <span>{marketConnectCountFromAPi}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested<br /> <span style={{ color: "#78417C" }}>{marketConnectRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Opportunities Availed<br/> <span style={{ color: "#78417C" }}>{marketConnectDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *2 market connect opportunities per 20 entrepreneurs
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${compliancesession}`} download={`${compliancesession}`}>
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Compliance <span className='astrixStyle'>*</span></label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>100</span></h5> */}
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{complianceData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {complianceDeliveredCountFromApi > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${compliancesessionAsOnFileName}`} download={`${compliancesessionAsOnFileName}`}>
                                        {/* {complianceData} */}
                                        {complianceDeliveredCountFromApi}
                                    </a>
                                ) : (
                                    <span>{complianceDeliveredCountFromApi}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        {/* <div style={{ clear: "both" }}></div> */}
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{complianceRequested}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress <br /> <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{complianceCancellled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *As per the best required license for each entrepreneur
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="con-cursor-pointer" style={{ color: "#000000", cursor: "pointer" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${socialMediaSession}`} download={`${socialMediaSession}`}>
                            {/* <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Social Media Readiness Program</label> */}
                            <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "pointer" }}>Marketing</label>
                        </a>
                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            <h5 className="esp-count-text">Target <br /> <span className='boxCardTextStyle' style={{ color: "#78417C" }}>60 <span className='astrixStyle' style={{marginTop:"-5px"}}>*</span></span></h5>
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {socialMediaCountFromApi > 0 ? (
                                    <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${socialMediaSessionAsOnFileName}`} download={`${socialMediaSessionAsOnFileName}`}>
                                        {socialMediaCountFromApi}
                                    </a>
                                ) : (
                                    <span>{socialMediaCountFromApi}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{blrpRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested <br /> <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{socialMediaDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{socialMediaCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{socialMediaDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                {`*Creation of digital presence (1 service) and managing social media for 2 months(2 services) for each entrepreneur`}
                            </span>
                        </div>
                    </div>
                </div>

            </div>

            {/* <div className='row mb-3 text-center'>
                <div className='col-12'>
                    <div className='esp-count-text'>
                        <span style={{color: 'red'}}>
                        Note: The number indicates both, the services in progress and delivered.
                        </span>
                    </div>
                </div>
            </div> */}

            <div style={{
                borderBottom: "2px solid lightgray"
            }}></div>

            <div className="row mt-3 mb-2">
                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    <HistogramTotalBeneficiaryChart isLoading={isLoading} data={totalBeneChartData} />
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    <DeliveredResourcePieChart data={summaryData} />
                </div>
            </div>

            {/* <div className="row mt-3 mb-2">
                <div className="col-6">
                    <DataPieChart data={combineData}/> 
                </div>

                <div className="col-6">
                    <CustomHistogramChart isLoading={isLoading} data={combineData}/> 
                </div>
            </div> */}

            <div className="row mt-3 mb-2">
                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    {/* <DataPieChart data={combineData}/>  */}
                    <CompliancePieChart data={filteredCompliance} />
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    <MarketLinkagePieChart data={filteredMarketLinkage} />
                    {/* <CustomHistogramChart isLoading={isLoading} data={combineData}/>  */}
                </div>
            </div>

            {/* <div className="row mt-3 mb-2">
                <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <MarketingPieChart data={marketingPieChartData} />
                </div>
            </div> */}

            {
                loadMore &&
                <>
                    <div className="row mt-2 mb-2">
                        {/* <div className="col-md-12">
                            <IhclMainTable isLoading={isLoading} data={combineData} />
                        </div> */}
                    </div>

                    {/* <div className="row mt-2 mb-2">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <AgeWiseIhclTable isLoading={isLoading} data={ageWiseData} />
                        </div>

                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <IncomeIhclTable isLoading={isLoading} data={businessIncData} />
                        </div>
                    </div> */}

                    {/* <div className="row mt-2 mb-4">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <SectorWiseIhclTable isLoading={isLoading} data={sectorWiseData} />
                        </div>

                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <FamilyIncomeIhclTable isLoading={isLoading} data={familyIncData} />
                        </div>
                    </div> */}

                    {/* <div className="row mt-2 mb-4">
                        <div className="col-md-12">
                            <IhclExpenseTable isLoading={isLoading} data={jpmcExpsData} />
                        </div>
                    </div> */}
                </>
            }

            {
                !loadMore &&
                <div className='d-flex justify-content-center mt-2 mb-3'>
                    {/* <button className="my-services-model-cancel-btn" onClick={() => setLoadMore(true)} >Load More</button> */}
                </div>
            }

        </div>
        ) : (
            <div className={`${isLoading && "set-opacity"}`}>
            {isLoading && <Spinner className="center-screen" />}
            <div className='row mt-2 ml-1'>
                <div className="esp-dashboard-card1 conv-text-center" style={{ height: '38px', paddingleft: '10px', marginRight: "20px" }}>
                    {/* <label className="esp-box-header-title">Mobilization: {mobilizationCountData || 0}</label> */}
                    {/* <h5 className="esp-count-text">{0}</h5> */}
                    <label className="esp-box-header-title">Mobilization: {mobilizationCountData || 0}</label>
                    <div style={{ clear: "both" }}></div>

                </div>
                {/* <div className="col-12"> */}
                {/* <div className='col-2'> */}
                {/* <a className="con-cursor-pointer"
                                href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData ${getCurrentDate()}.xlsx`} download={`JPMCDashboardData ${getCurrentDate()}.xlsx`}>

                                <button
                            className="lpm-con-btn-filled conv-pr35 conv-pl35">
                            Download CSV
                        </button>

                            </a>     */}

                <a className="">
                    <button
                        className="lpm-con-btn-filled conv-pr35 conv-pl35">
                        Download CSV
                    </button>

                </a>

                {/* <div className='esp-count-text' style={{
                    border: '1px solid gray',
                    borderRadius: '2px',
                    height: 'fit-content',
                    padding: '5px 28px',
                    marginLeft: '25px',
                    marginRight: '10px',
                    backgroundColor: '#eee'
                }}>
                    Mobilization: <br/>1000
                </div> */}


                {/* </div> */}

                <div className="col-6 ml-1">
                    <div className="row">
                        <div className="col-4 spled-container conv-zindex">
                            <div className="width-100">
                                <ReactDatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={fromDate}
                                    onChange={(date) => ondatechange("fromDate", date)}
                                    placeholderText="From Date"
                                    minDate={new Date("01-01-2024")}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>

                        <div className="col-4 spled-container conv-zindex">
                            <div className="width-100">
                                <ReactDatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={toDate}
                                    onChange={(date) => ondatechange("toDate", date)}
                                    placeholderText="To Date"
                                    minDate={new Date("01-01-2024")}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>

                        <div className="col-4">
                            <Button className="esp-inline-button mr-2" style={{
                                width: "80px", height: '38px'
                            }} onClick={handleSearch} >Search</Button>
                            <Button className="esp-inline-button" style={{
                                width: '80px', height: '38px'
                            }} onClick={handleClear} >Clear</Button>
                        </div>

                    </div>
                </div>

                {/* </div> */}



            </div>

            <div className="row mb-4">

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                            <label className="esp-box-header-title mt-2">Eligible</label>

                        {/* <div className='row esp-box-header-title mt-4'>
                            <div className="col-4"></div>
                            <div className="col-4">Mobilization</div>
                            <div className="col-4">Eligible</div>
                        </div>
                        <div className='row esp-count-text mt-2'>
                            <div className="col-4">Target <br/> <span style={{ color: "#78417C" }}>2000</span></div>
                            <div className="col-4">As on date <br/> <span style={{ color: "#78417C" }}>{mobilizationCountData || 0}</span></div>
                            <div className="col-4">As on date <br/>
                            <span style={{ color: "#78417C" }}>
                                    {countData > 0 ? (
                                        <a className="con-cursor-pointer" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/Eligible ${getCurrentDate()}.xlsx`} download={`Mobilization ${getCurrentDate()}.xlsx`}>
                                            {countData}
                                        </a>
                                    ) : (
                                        <span>{countData}</span>
                                    )}
                            </span>
                            </div>/
                        </div> */}
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
                            <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>20</span></h5>
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {eligibleAsOnDate > 0 ? (
                                    <a className="" style={{ color: "#78417C" }} >
                                       {eligibleAsOnDate}
                                    </a>
                                    // <span>{20}</span>
                                ) : (
                                    <span>{0}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div style={{ justifyContent: 'space-around', padding: "35px" }}></div>
                        {/*<div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *The eligible entrepreneurs were identified for further interventions                        </span>
                        </div>*/}
                    </div>
                </div>

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff"
                        height: "220px",
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="" style={{ color: "#000000", cursor: "" }}>
                            <label className="esp-box-header-title mt-2" style={{ cursor: "" }}>Group Knowledge Session</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px', backgroundColor:"" }}>
                            <h5 className="esp-count-text" style={{backgroundColor:""}}>Target <br /> <span className='boxCardTextStyle' style={{ color: "#78417C"}}>{2*20}<span className='astrixStyle' style={{marginTop:"-5px"}}>*</span></span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{groupKnowledgeData || 0}</span></h5> */}
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>
                                <a className="con-cursor-pointer" style={{ color: "#78417C" }}
                                    href={`${DOWNLOAD_API_URL}/static_live/Reports/JPMCDashboardData.xlsx`} download="JPMCDashboardData.xlsx">
                                    {groupKnowledgeData || 0}
                                </a>
                            </span>
                            </h5> */}
                            <h5 className="esp-count-text"
                            //  title='Requested = 10&#10;In Progress = 3&#10;Delivered = 10'
                            // title={title}

                            >As on Date <br /> <span style={{ color: "#78417C" }}>
                                    {groupKnowledgeSessionCountFromApi > 0 ? (
                                        <>
                                            <a className="" style={{ color: "#78417C" }}>
                                                {groupKnowledgeSessionCountFromApi}
                                            </a>
                                            {/* <span>{0}</span> */}
                                        </>
                                    ) : (
                                        <span>{groupKnowledgeSessionCountFromApi}</span>
                                    )}
                                </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested <br /> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Attended <br/> <span style={{ color: "#78417C" }}>{groupKnowledgeSessionDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *2 Group knowledge sessions per 20 entrepreneurs
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="" style={{ color: "#000000", cursor: "" }}>
                            <label className="esp-box-header-title mt-2" style={{ cursor: "" }}>Expert Consultation</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: '15px' }}>
                            <h5 className="esp-count-text">Target <br /> <span className='boxCardTextStyle' style={{ color: "#78417C" }}>{3*20}<span className='astrixStyle' style={{marginTop:"-5px"}}>*</span></span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{expertData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {expertConsultationCountFromAPi > 0 ? (
                                    <a className="" style={{ color: "#78417C" }} href={`${DOWNLOAD_API_URL}/static_live/Reports/${expertConsultationAsOnFilename}`} download={`${expertConsultationAsOnFilename}`}>
                                        {expertConsultationCountFromAPi}
                                        {/* {expertConsultationCountFromAPi} */}
                                    </a>
                                ) : (
                                    // <span>{expertData}</span>
                                    <span>{expertConsultationCountFromAPi}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{expertConsultationRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested <br /> <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *3 one-on-one sessions per 20 entrepreneurs
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-2 mb-4">
                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="" style={{ color: "#000000", cursor: "" }}>
                            <label className="esp-box-header-title mt-2" style={{ cursor: "" }}>Market Connect</label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            <h5 className="esp-count-text">Target <br /> <span className='boxCardTextStyle' style={{ color: "#78417C" }}>{2*20} <span className='astrixStyle' style={{marginTop:"-5px"}}>*</span></span></h5>
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{marketConnectData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {marketConnectCountFromAPi > 0 ? (
                                    <a className="" style={{ color: "#78417C" }}>
                                        {/* {marketConnectData} */}
                                        {marketConnectCountFromAPi}
                                    </a>
                                ) : (
                                    <span>{marketConnectCountFromAPi}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested<br /> <span style={{ color: "#78417C" }}>{marketConnectRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Opportunities Availed<br/> <span style={{ color: "#78417C" }}>{marketConnectDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{experConsultationCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{expertConsultationProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{expertConsultationDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *2 market connect opportunities per 20 entrepreneurs
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="" style={{ color: "#000000", cursor: "" }}>
                            <label className="esp-box-header-title mt-2" style={{ cursor: "" }}>Compliance <span className='astrixStyle'>*</span></label>
                        </a>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="esp-count-text">Target <br /> <span style={{ color: "#78417C" }}>100</span></h5> */}
                            {/* <h5 className="esp-count-text">As on Date: <span style={{ color: "#78417C" }}>{complianceData || 0}</span></h5> */}
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {complianceDeliveredCountFromApi > 0 ? (
                                    <a className="" style={{ color: "#78417C" }}>
                                        {/* {complianceData} */}
                                        {complianceDeliveredCountFromApi}
                                    </a>
                                ) : (
                                    <span>{complianceDeliveredCountFromApi}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        {/* <div style={{ clear: "both" }}></div> */}
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{complianceRequested}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress <br /> <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
                        </div>
                        
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{complianceCancellled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{complianceProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{complianceDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                                *As per the best required license for each entrepreneur
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-4">
                    <div style={{
                        backgroundColor: '#eee',
                        // color: "#fff",
                        height: '220px'
                    }} className="esp-dashboard-card conv-text-center w-100"
                    // title='Displays the Count of First Time users where mobile number is mandatory + all the count before that.'
                    >
                        <a className="" style={{ color: "#000000", cursor: "" }}>
                            {/* <label className="esp-box-header-title mt-2 hover-underline" style={{ cursor: "" }}>Social Media Readiness Program</label> */}
                            <label className="esp-box-header-title mt-2" style={{ cursor: "" }}>Marketing</label>
                        </a>
                         <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            <h5 className="esp-count-text">Target <br /> <span className='boxCardTextStyle' style={{ color: "#78417C" }}>60 <span className='astrixStyle' style={{marginTop:"-5px"}}>*</span></span></h5>
                            <h5 className="esp-count-text">As on Date <br /> <span style={{ color: "#78417C" }}>
                                {socialMediaCountFromApi > 0 ? (
                                    <a className="" style={{ color: "#78417C" }}>
                                        {socialMediaCountFromApi}
                                    </a>
                                ) : (
                                    <span>{socialMediaCountFromApi}</span>
                                )}
                            </span>
                            </h5>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px" }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Requested <br /> <span style={{ color: "#78417C" }}>{blrpRequested}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Interested <br /> <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered <br/> <span style={{ color: "#78417C" }}>{socialMediaDelivered}</span></h5> */}
                        </div>
                        <div className='d-flex align-items-center' style={{ justifyContent: 'space-around', padding: "15px", paddingTop: '5px' }}>
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>Cancelled: <span style={{ color: "#78417C" }}>{socialMediaCancelled}</span></h5> */}
                            {/* <h5 className="count-text" style={{
                                color: '#000'
                            }}>In Progress: <span style={{ color: "#78417C" }}>{blrpProgress}</span></h5>
                            <h5 className="count-text" style={{
                                color: '#000'
                            }}>Delivered: <span style={{ color: "#78417C" }}>{socialMediaDelivered}</span></h5> */}
                        </div>
                        <div className='count-text'>
                            <span style={{ color: 'lightslategray' }}>
                            {`*Creation of digital presence (1 service) and managing social media for 2 months(2 services) for each entrepreneur`}
                            </span>
                        </div>
                    </div>
                </div>

            </div>

            {/* <div className='row mb-3 text-center'>
                <div className='col-12'>
                    <div className='esp-count-text'>
                        <span style={{color: 'red'}}>
                        Note: The number indicates both, the services in progress and delivered.
                        </span>
                    </div>
                </div>
            </div> */}

            <div style={{
                borderBottom: "2px solid lightgray"
            }}></div>

            <div className="row mt-3 mb-2">
                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    <HistogramTotalBeneficiaryChart isLoading={isLoading} data={totalBeneChartData} />
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    <DeliveredResourcePieChart data={summaryData} />
                </div>
            </div>

            {/* <div className="row mt-3 mb-2">
                <div className="col-6">
                    <DataPieChart data={combineData}/> 
                </div>

                <div className="col-6">
                    <CustomHistogramChart isLoading={isLoading} data={combineData}/> 
                </div>
            </div> */}

            <div className="row mt-3 mb-2">
                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    {/* <DataPieChart data={combineData}/>  */}
                    <CompliancePieChart data={filteredCompliance} />
                </div>

                <div className="col-lg-6 col-md-12 col-sm-12 mt-2">
                    <MarketLinkagePieChart data={filteredMarketLinkage} />
                    {/* <CustomHistogramChart isLoading={isLoading} data={combineData}/>  */}
                </div>
            </div>

            {/* <div className="row mt-3 mb-2">
                <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                    <MarketingPieChart data={marketingPieChartData} />
                </div>
            </div> */}

            {
                loadMore &&
                <>
                    <div className="row mt-2 mb-2">
                        {/* <div className="col-md-12">
                            <IhclMainTable isLoading={isLoading} data={combineData} />
                        </div> */}
                    </div>

                    {/* <div className="row mt-2 mb-2">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <AgeWiseIhclTable isLoading={isLoading} data={ageWiseData} />
                        </div>

                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <IncomeIhclTable isLoading={isLoading} data={businessIncData} />
                        </div>
                    </div> */}

                    {/* <div className="row mt-2 mb-4">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <SectorWiseIhclTable isLoading={isLoading} data={sectorWiseData} />
                        </div>

                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <FamilyIncomeIhclTable isLoading={isLoading} data={familyIncData} />
                        </div>
                    </div> */}

                    {/* <div className="row mt-2 mb-4">
                        <div className="col-md-12">
                            <IhclExpenseTable isLoading={isLoading} data={jpmcExpsData} />
                        </div>
                    </div> */}
                </>
            }

            {
                !loadMore &&
                <div className='d-flex justify-content-center mt-2 mb-3'>
                    {/* <button className="my-services-model-cancel-btn" onClick={() => setLoadMore(true)} >Load More</button> */}
                </div>
            }

        </div>
        )
    )
}

export default IhclDashboardContainer

